<template>
  <div>
    <template class="page" v-if="coupon">
      <div class="page__title">
        {{ getModuleConfig("select_item_page.form_title") }}
      </div>
      <div
        class="page__desc"
        v-html="getModuleConfig('select_item_page.form_desc')"
      ></div>
      <div  class="page__content" v-if="getModuleConfig('select_item_page.content')" v-html="getModuleConfig('select_item_page.content')"></div>

      <div>
        <Loading v-if="showLoading" loading-message="載入中..." />
        <div v-else-if="!showLoading" class="page">
          <div class="field">
            <!-- <label class="field__label"> 我的代理商 </label> -->
            <div class="row">
              <div
                class="col-12 px-2"
                v-for="(option, idx) in options"
                :key="idx"
              >
                <SharedRadio
                  v-model="proxy"
                  :id="`proxy-${idx}`"
                  :value="option.value"
                  name="proxy"
                >
                  {{ option.text }}
                </SharedRadio>
              </div>
            </div>
          </div>

          <small>{{ getModuleConfig("select_item_page.form_memo") }}</small>
        </div>
      </div>

      <div
        v-if="
          getModuleConfig('select_item_page.button_text') ||
          getModuleConfig('select_item_page.cancel_button_text')
        "
        class="p-3 fixed-bottom bg-white footer"
      >
        <SharedButton
          :disabled="!proxy"
          @click="confirmSelectItem"
          class="s-btn-bg-primary mb-2"
          >{{ getModuleConfig("select_item_page.button_text") }}</SharedButton
        >

        <MemberButton
          :button-style='`s-btn-outline-primary`'
          :button-text="getModuleConfig('select_item_page.cancel_button_text')"
          :button-url="getModuleConfig('select_item_page.cancel_button_url')"
          :type="getModuleConfig('select_item_page.cancel_button_action')"
        ></MemberButton>

        <!-- <SharedButton variant="outline-dark" class="s-btn-outline-primary">{{
          getModuleConfig("select_item_page.cancel_button_text")
        }}</SharedButton> -->
      </div>
    </template>
    <template v-else>
        <div class="coupon--header">
            <div class="s-px-3 s-text-2xl s-font-bold text-truncate">
                {{ errorMessage }}
            </div>
        </div>
        <div class="p-3 fixed-bottom bg-white footer">
          <MemberButton
            :button-style='`s-btn-outline-primary`'
            :button-text="getModuleConfig('select_item_page.cancel_button_text')"
            :button-url="getModuleConfig('select_item_page.cancel_button_url')"
            :type="getModuleConfig('select_item_page.cancel_button_action')"
          ></MemberButton>
        </div>
    </template>
  </div>
</template>

<script>
import MemberButton from "@/components/Page/Liff/Shared/MemberButton.vue";
import Loading from "@/components/Page/Liff/Shared/Loading";
import SharedButton from "@/components/Page/Liff/Shared/Button";
import couponMixin from "@/mixins/liff/coupon";
import SharedRadio from "@/components/DynamicForm/Radio.vue";
import abbottAndApi from "@/apis/liff/v2/proj/abbott-and";
import abbottAndMixin from "@/mixins/liff/proj/abbott-and";
import { mapActions, mapGetters } from 'vuex';

export default {
  mixins: [couponMixin, abbottAndMixin],
  components: { Loading, SharedButton, SharedRadio, MemberButton },
  data() {
    return {
      showLoading: false,
      options: [],
      proxy: null,
      coupon: true,
      couponData: null,
      errorMessage: "",
    };
  },

  computed: {
    ...mapGetters({
      redeemData: "projAbbottAnd/redeemData",
    }),
  },
  async mounted() {
    console.log("[AND CouponSelectItem] ========== CouponSelectItem.vue mounted() ==========");
    console.log("[AND CouponSelectItem] Route params:", this.$route.params);
    console.log("[AND CouponSelectItem] Current redeemData from store:", this.redeemData);
    await this.fetchCoupon();
  },

  methods: {
    ...mapActions('projAbbottAnd', ['setRedeemData', 'setCouponIdData', 'setCouponType', 'setThanksMessage']),

    async confirmSelectItem() {
      console.log("[AND CouponSelectItem] confirmSelectItem() called");
      console.log("[AND CouponSelectItem] Selected proxy (item_id):", this.proxy);

      this.showLoading = true;

      const redeemData = {
        coupon_id: this.$route.params.id,
        item_id: this.proxy,
        item_name: this.options.find((item) => item.value === this.proxy)?.text,
      };
      console.log("[AND CouponSelectItem] Setting redeemData:", redeemData);
      await this.setRedeemData(redeemData);

      // 設定 coupon_id 和 coupon_type
      await this.setCouponIdData(this.$route.params.id);

      // 根據 coupon code 判斷 coupon_type
      const couponType = this.couponData?.code?.includes("BG_H") ? "2" : "1";
      console.log("[AND CouponSelectItem] Coupon code:", this.couponData?.code, "-> couponType:", couponType);
      await this.setCouponType(couponType);

      // 新流程：直接執行核銷
      console.log("[AND CouponSelectItem] Calling confirmCoupon() directly (new flow)");
      await this.confirmCoupon();

      this.showLoading = false;
    },

    async fetchCoupon() {
      console.log("[AND CouponSelectItem] fetchCoupon() called");
      await abbottAndApi.getCouponDetail(
        this.$route.params.orgCode,
        {
          coupon_id: this.$route.params.id,
          store_code: this.redeemData.store_code
        }).then((res) => {
          console.log("[AND CouponSelectItem] Coupon detail response:", res.data);
          this.couponData = res.data.data;
          this.options = res.data.data.items.map((item) => {
            return {
              text: item.name,
              value: String(item.id),
            }
          })
          console.log("[AND CouponSelectItem] Item options:", this.options);
          if (this.options.length === 0) {
            console.log("[AND CouponSelectItem] No items, auto-confirming...");
            this.confirmSelectItem()
          }
      }).catch((err) => {
        console.error("[AND CouponSelectItem] Error fetching coupon:", err);
        this.coupon = false;
        if (this.options.length === 0) {
          this.errorMessage = "此優惠券核銷選項不存在";
        } else {
          this.errorMessage = "此優惠券不存在";
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.field {
  &__label {
    font-size: 20px;
    margin-bottom: 8px;
  }
  &__input {
    font-size: 18px;
    background-color: #ffffff;
  }

  &__desc {
    font-size: 16px !important;
  }
}

.row {
  margin: 0 -0.5rem;
}

.coupon {
  display: flex;
  flex-direction: column;
  text-align: center;

  box-sizing: content-box;


  border-radius: 10px;
  background-size: 100% 100% ;
  background-repeat: no-repeat;
  background-image: radial-gradient(circle at 50% 101%, rgba(white,0) 1.5em, white (1.6em));
  background-position: top left, top right;
  filter: drop-shadow(0 2px 8px rgba(black,.3));
  padding-bottom: 1.5em;



  &--header {
    background: var(--liff-header-color);
    color: var(--liff-header-text-color);
    padding: 15px 10px 10px 10px;
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
    border-top: 1px solid var(--liff-header-text-color);
    border-left: 1px solid var(--liff-header-text-color);
    border-right: 1px solid var(--liff-header-text-color);
  }

  &--barcode {
    font-weight: 400;
    font-size: 16px;
    line-height: 18px;
  }

  &--wrapper{
    overflow-y: scroll;
  }

  &--image {
    margin: 12px;

    img {
      width: 100%;
      border-top-left-radius: 12px;
      border-top-right-radius: 12px;
    }
  }

  &--body {
    padding: 0 30px;
    margin: 0 12px 12px 12px;
  }

  &--footer {
    padding: 0 24px 12px;

    .coupon-confirm {
      color: #ea0000;
      font-size: 14px;
    }
  }

  &--copy-panel {
    background: #f2f2f7;
    border-radius: 10px;
    padding: 12px 8px;
    position: relative;
  }

  &--copy-button {
    background: rgba(102, 153, 204, 0.03);
    border: 1px solid rgba(102, 153, 204, 0.6);
    color: #3973ac;
    padding: 4px 16px;
    border-radius: 10px;
    font-weight: 600;
    font-size: 13px;
    line-height: 18px;
    position: absolute;
    right: 8px;
    top: 10px;
  }

  &--line {
    border: 1px dashed #dadada;
  }

  button {
    font-size: 16px;

    &.s-btn-bg-primary {
      background: var(--liff-button-color);
      color: var(--liff-button-text-color);
    }
  }
}
</style>
